<script>
import Feedback from '@views/progress/feedback'

export default {
  page: {
    title: 'DataViz',
    meta: [{ name: 'description', content: 'dataViz page...' }],
  },
  components: { Feedback },
}
</script>

<template>
  <v-layout column>
    <router-view/>
    <Feedback/>
  </v-layout>
</template>
